// extracted by mini-css-extract-plugin
module.exports = {"tabsBoxShadow":"AtSearch_tabsBoxShadow__2Ksm8","pageContainer":"AtSearch_pageContainer__3Q_JQ","notActive":"AtSearch_notActive__1MGHu","active":"AtSearch_active__TgRHA"};